import React from "react";
import logo from "../../assets/UserPanelAssets/img/logo.svg";
import logoWhite from "../../assets/UserPanelAssets/img/logo-white.svg";
import trustCare from "../../assets/UserPanelAssets/img/icons/trust-care.svg";
import signatureImg from "../../assets/UserPanelAssets/img/icons/signature-img.svg";

export default function DetailedPescription() {
  return (
    <div className="content">
      <div className="row">
        <div className="col-lg-10 mx-auto">
          <div className="d-flex align-items-sm-center flex-sm-row flex-column mb-4">
            <div className="flex-grow-1">
              <h6 className="fs-14 fw-semibold mb-0 d-flex align-items-center">
                <a href="patient-prescriptions.html" className="me-1">
                  <i className="ti ti-chevron-left"></i> Prescriptions
                </a>
              </h6>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between border-1 border-bottom pb-3 mb-3">
                <div className="invoice-logo">
                  <img src={logo} className="logo-white" alt="logo" />
                  <img src={logoWhite} className="logo-dark" alt="logo" />
                </div>
                <span className="badge bg-info-subtle text-info-emphasis fs-13 fw-medium border border-primary py-1 px-2">
                  #PRE0025
                </span>
              </div>

              <div className="d-flex align-items-center justify-content-between border-1 border-bottom pb-3 mb-3 flex-wrap gap-2">
                <div className="d-flex align-items-center gap-2">
                  <div className="avatar avatar-xxl rounded bg-light border p-2">
                    <img
                      src={trustCare}
                      alt="favicon"
                      className="img-fluid img1"
                    />
                  </div>
                  <div>
                    <h6 className="text-dark fw-semibold mb-1">
                      Trustcare Clinic
                    </h6>
                    <p className="mb-1">Dr. Mick Thompson</p>
                    <p className="mb-0">MD Cardiologist. MBBS, MS</p>
                  </div>
                </div>

                <div className="text-lg-end">
                  <p className="text-dark mb-1">
                    Department :{" "}
                    <span className="text-body">Cardiology OP</span>
                  </p>
                  <p className="text-dark mb-1">
                    Prescribed on :{" "}
                    <span className="text-body">25 Jan 2025, 09:00 AM</span>
                  </p>
                  <p className="text-dark mb-0">
                    Consultation : <span className="text-body">Video</span>
                  </p>
                </div>
              </div>

              <div className="mb-3">
                <h6 className="mb-2 fs-14 fw-medium">Patient Details</h6>
                <div className="px-3 py-2 bg-light rounded d-flex align-items-center justify-content-between">
                  <h6 className="m-0 fw-semibold fs-16">M. Reyan Verol</h6>
                  <div className="d-flex align-items-center gap-3">
                    <p className="mb-0 text-dark">28Y / Male</p>
                    <p className="mb-0 text-dark">
                      <span className="text-body">Blood</span> : O+ve
                    </p>
                    <p className="mb-0 text-dark">
                      Patient ID <span className="text-body">PT0025</span>
                    </p>
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <h6 className="mb-3 fs-16 fw-bold text-center">
                  Cardiology Prescription
                </h6>

                <div className="table-responsive border bg-white">
                  <table className="table table-nowrap">
                    <thead>
                      <tr>
                        <th>SNO</th>
                        <th>Medecine Name</th>
                        <th>Dosage</th>
                        <th>Frequency</th>
                        <th>Duration</th>
                        <th>Timings</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>01</td>
                        <td>General Medicine</td>
                        <td>Ecosprin 75MG</td>
                        <td>1-0-1</td>
                        <td>1 month</td>
                        <td>Before meal</td>
                      </tr>
                      <tr>
                        <td>02</td>
                        <td>Axer 90MG Tab</td>
                        <td>90 mg</td>
                        <td>1-1-1</td>
                        <td>1 month</td>
                        <td>After meal</td>
                      </tr>
                      <tr>
                        <td>03</td>
                        <td>Ramistar XL 2.5</td>
                        <td>75 ml</td>
                        <td>1-0-1</td>
                        <td>1 month</td>
                        <td>After meal</td>
                      </tr>
                      <tr>
                        <td>04</td>
                        <td>General Medicine</td>
                        <td>Ecosprin 75MG</td>
                        <td>1-0-1</td>
                        <td>1 month</td>
                        <td>Before meal</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="pb-3 mb-3 border-1 border-bottom">
                <h6 className="mb-1 fs-16 fw-semibold">Advice</h6>
                <p>
                  An account of the present illness, including recent health
                  changes, events timeline, and medications affecting the
                  condition.
                </p>
              </div>

              <div className="pb-3 mb-3 border-1 border-bottom d-flex align-items-center justify-content-between flex-wrap gap-2">
                <div>
                  <h6 className="mb-1 fs-16 fw-semibold">Follow Up</h6>
                  <p>Follow up after 3 months. Come on an empty stomach.</p>
                </div>
                <div>
                  <img
                    src={signatureImg}
                    alt="signature"
                    className="img-fluid"
                  />
                  <h6 className="fs-14 fw-semibold">Dr. Mick Thompson</h6>
                  <p className="fs-13 fw-normal">MD Cardiologist</p>
                </div>
              </div>

              <div className="text-center d-flex align-items-center justify-content-center">
                <a
                  href="#"
                  className="btn btn-md btn-dark me-2 d-flex align-items-center"
                >
                  <i className="ti ti-printer me-1"></i> Print
                </a>
                <a
                  href="#"
                  className="btn btn-md btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-download me-1"></i> Download
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
